import axios from "axios";
import { apiConfig } from "@/config/baseUrl";
import { ApiResponse, } from "@/models/Apiresponse";
import { UserGeneralKey, UserRole } from "@/models/user.generalkey";
export const apiClient = axios.create({
    baseURL: apiConfig.baseURL,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
export const apiClientFormData = axios.create({
    baseURL: apiConfig.baseURL,
    headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
    },
});
export const marketingApiClient = axios.create({
    baseURL: apiConfig.marketingURL,
    headers: {
        "Content-Type": "application/json",
        Accepts: "application/json",
    },
});
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
    if (token && token !== "undefined" && token !== "null") {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    const currentLanguage = localStorage.getItem('app-language') || 'fr';
    const normalizedLang = currentLanguage.toLowerCase().split('-')[0];
    if (['fr', 'en', 'de', 'it'].includes(normalizedLang)) {
        config.headers["X-Language"] = normalizedLang;
        config.headers["Accept-Language"] = normalizedLang;
    }
    else {
        config.headers["X-Language"] = 'fr';
        config.headers["Accept-Language"] = 'fr';
    }
    if (!config.headers["X-Franchise-ID"]) {
        const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
        if (franchiseId && franchiseId !== "undefined" && franchiseId !== "null") {
            config.headers["X-Franchise-ID"] = franchiseId;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
apiClient.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        UserGeneralKey.logout();
        window.location.href = "/";
        return Promise.reject(new Error("Token expiré - Redirection vers la page de connexion"));
    }
    return Promise.reject(error);
});
apiClientFormData.interceptors.request.use((config) => {
    const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    const currentLanguage = localStorage.getItem('app-language') || 'fr';
    const normalizedLang = currentLanguage.toLowerCase().split('-')[0];
    if (['fr', 'en', 'de', 'it'].includes(normalizedLang)) {
        config.headers["X-Language"] = normalizedLang;
        config.headers["Accept-Language"] = normalizedLang;
    }
    else {
        config.headers["X-Language"] = 'fr';
        config.headers["Accept-Language"] = 'fr';
    }
    if (!config.headers["X-Franchise-ID"]) {
        const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
        if (franchiseId && franchiseId !== "undefined" && franchiseId !== "null") {
            config.headers["X-Franchise-ID"] = franchiseId;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
apiClientFormData.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        UserGeneralKey.logout();
        window.location.href = "/";
        return Promise.reject(new Error("Token expiré - Redirection vers la page de connexion"));
    }
    return Promise.reject(error);
});
/* --- MARKETING API INTERCEPTORS --- */
marketingApiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
    if (token && token !== "undefined" && token !== "null") {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    const lang = (localStorage.getItem('app-language') || 'fr').toLowerCase().split('-')[0];
    config.headers["X-Language"] = lang;
    config.headers["Accept-Language"] = lang;
    if (!config.headers["X-Franchise-ID"]) {
        const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
        if (franchiseId && franchiseId !== "undefined" && franchiseId !== "null") {
            config.headers["X-Franchise-ID"] = franchiseId;
        }
    }
    return config;
}, (error) => Promise.reject(error));
marketingApiClient.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        UserGeneralKey.logout();
        window.location.href = "/";
    }
    return Promise.reject(error);
});
export const loginCheck = async (auth) => {
    try {
        const currentLanguage = localStorage.getItem('app-language') || (typeof navigator !== 'undefined' ? navigator.language : null) || 'fr';
        const normalizedLang = currentLanguage.toLowerCase().split('-')[0];
        const lang = ['fr', 'en', 'de', 'it'].includes(normalizedLang) ? normalizedLang : 'fr';
        const response = await axios.post(`${apiConfig.baseURL}/login_office`, auth, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Language": lang,
                "Accept-Language": lang,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la tentative de connection.", error);
        throw error;
    }
};
export const resetPasswordStepOne = async (email) => {
    try {
        const response = await apiClient.post("/user/reset_password", email);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la reinitialisation de password.", error);
        throw error;
    }
};
export const resetPasswordStepTwo = async (resetData) => {
    try {
        const response = await apiClient.patch("/user/reset_password/confirm", resetData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la tentative de connection.", error);
        throw error;
    }
};
export const createUser = async (userData) => {
    try {
        const response = await apiClient.post("/user", userData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation d'un compte utilisateur", error);
        throw error;
    }
};
export const getUserData = async () => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/user/detail`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const listeUser = async (page = 1, limit = 10, searchParams) => {
    // eslint-disable-next-line no-useless-catch
    try {
        let url = `/v1/user/all/${page}?limit=${limit}`;
        if (searchParams) {
            const params = new URLSearchParams();
            if (searchParams.searchFirstname) {
                params.append('searchFirstname', searchParams.searchFirstname);
            }
            if (searchParams.searchLastname) {
                params.append('searchLastname', searchParams.searchLastname);
            }
            if (searchParams.searchEmail) {
                params.append('searchEmail', searchParams.searchEmail);
            }
            if (searchParams.searchTel) {
                params.append('searchTel', searchParams.searchTel);
            }
            if (searchParams.restaurantId) {
                params.append('restaurantId', searchParams.restaurantId);
            }
            const queryString = params.toString();
            if (queryString) {
                url += `&${queryString}`;
            }
        }
        const response = await apiClient.get(url);
        const paginatedData = {
            items: response.data.data || [],
            pagination: response.data.pagination ? {
                current_page: parseInt(response.data.pagination.page || String(page)),
                total_items: parseInt(response.data.pagination.total || "0"),
                total_pages: parseInt(response.data.pagination.totalPages || "0"),
                items_per_page: parseInt(response.data.pagination.limit || String(limit)),
            } : {
                current_page: page,
                total_items: (response.data.data || []).length,
                total_pages: 1,
                items_per_page: limit,
            }
        };
        return new ApiResponse(response.data.code, response.data.message, paginatedData);
    }
    catch (error) {
        throw error;
    }
};
export const deleteUser = async (userID) => {
    try {
        const response = await apiClient.delete(`/v1/user/delete/${userID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du compte", error);
        throw error;
    }
};
export const detailUser = async (userID) => {
    try {
        const response = await apiClient.get(`/v1/user/detail/${userID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la lecture du compte utilisateur", error);
        throw error;
    }
};
export const updateUser = async (userID, userData) => {
    try {
        const response = await apiClient.put(`/v1/user/update/${userID}`, userData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour du compte utilisateur.", error);
        throw error;
    }
};
export const updateUserPassword = async (userID, userData) => {
    try {
        const response = await apiClient.put(`/v1/user/password/${userID}`, userData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour du compte utilisateur.", error);
        throw error;
    }
};
export const updateUserLinger = async (userID, updateLingerDto) => {
    try {
        const response = await apiClient.put(`/v1/user/linger/${userID}`, updateLingerDto);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour du linger utilisateur.", error);
        throw error;
    }
};
export const toggleActivationUser = async (userID, userData) => {
    try {
        const response = await apiClient.put(`/v1/user/activate/${userID}`, userData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation du compte utilisateur.", error);
        throw error;
    }
};
export const toggleActivationUserAdmin = async (userID, status) => {
    try {
        const response = await apiClient.put(`/v1/user/activate/admin/${userID}`, { status });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation admin du compte utilisateur.", error);
        throw error;
    }
};
export const fetchAllPostalCode = async () => {
    try {
        const restaurantId = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (!restaurantId || restaurantId === "undefined" || restaurantId === "null") {
            return { code: 200, message: "No restaurant ID", data: [] };
        }
        const response = await apiClient.get(`/v1/delivery/restaurant/${restaurantId}/postal-codes`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la recherche des codes postaux", error);
        throw error;
    }
};
export const fetchPostalCodesByRestaurant = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/delivery/restaurant/${restaurantId}/postal-codes`);
        return response.data;
    }
    catch (error) {
        console.error(`Erreur lors de la recherche des codes postaux pour le resto ${restaurantId}`, error);
        throw error;
    }
};
export const getUserAddresses = async (userID) => {
    try {
        const response = await apiClient.get(`/v1/user/adresseLocal/${userID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des adresses utilisateur", error);
        throw error;
    }
};
export const applyCoupon = async (couponData) => {
    try {
        const payload = {
            coupon: couponData.coupon,
            email: couponData.email,
            orderAmount: couponData.amount,
        };
        const response = await apiClient.post("/coupons/validate", payload);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("Erreur lors de l'application du coupon", error);
        throw error;
    }
};
export const getRestaurantDetails = async (restaurantID) => {
    try {
        const response = await apiClient.get(`/v1/restaurant/detail/${restaurantID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des détails du restaurant", error);
        throw error;
    }
};
export const getAllPostalCodes = async () => {
    try {
        const restaurantId = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (!restaurantId) {
            throw new Error("Restaurant ID non trouvé dans le localStorage");
        }
        const response = await apiClient.get(`/v1/delivery/restaurant/${restaurantId}/postal-codes`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des codes postaux", error);
        throw error;
    }
};
export const listefranchises = async (page = 1) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/franchise/filter/existing?page=${page}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailFranchise = async (franchiseID) => {
    if (!franchiseID || franchiseID === 'null' || franchiseID === 'undefined') {
        return new ApiResponse(400, "Invalid Franchise ID", null);
    }
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/franchise/detail/${franchiseID}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const createFranchise = async (franchiseData) => {
    try {
        const response = await apiClient.post("/v1/franchise", franchiseData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation d'une franchise", error);
        throw error;
    }
};
export const updateFranchise = async (franchiseID, franchiseData) => {
    try {
        const response = await apiClient.put(`/v1/franchise/update/${franchiseID}`, franchiseData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour de la franchise", error);
        throw error;
    }
};
export const toggleActivationFranchise = async (franchiseID, franchiseData) => {
    try {
        const response = await apiClient.put(`/v1/franchise/activate/${franchiseID}`, franchiseData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de la frachise.", error);
        throw error;
    }
};
export const deleteFranchise = async (franchiseID) => {
    try {
        const response = await apiClient.delete(`/v1/franchise/delete/${franchiseID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression de la franchise", error);
        throw error;
    }
};
export const uploadFranchiseLogo = async (franchiseID, logoFile) => {
    try {
        const formData = new FormData();
        formData.append('logo', logoFile);
        const response = await apiClientFormData.post(`/v1/franchise/upload-logo/${franchiseID}`, formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload du logo franchise", error);
        throw error;
    }
};
export const uploadFranchiseLogoLight = async (franchiseID, logoFile) => {
    try {
        const formData = new FormData();
        formData.append('logo_light', logoFile);
        const response = await apiClientFormData.post(`/v1/franchise/upload-logo-light/${franchiseID}`, formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload du logo light franchise", error);
        throw error;
    }
};
export const uploadFranchiseFavicon = async (franchiseID, faviconFile) => {
    try {
        const formData = new FormData();
        formData.append('favicon', faviconFile);
        const response = await apiClientFormData.post(`/v1/franchise/upload-favicon/${franchiseID}`, formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload du favicon franchise", error);
        throw error;
    }
};
export const listeRestaurant = async (page = 1, franchiseId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const config = {};
        if (franchiseId) {
            config.headers = { "X-Franchise-ID": franchiseId };
        }
        const response = await apiClient.get(`/restaurant/filter/existing?page=${page}`, config);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const getRestaurantsByFranchise = async () => {
    try {
        const response = await apiClient.get('/v1/restaurant/all');
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des restaurants de la franchise", error);
        throw error;
    }
};
export const getAllDailyClosures = async (params) => {
    try {
        const response = await apiClient.get('/v1/daily-closure/all', { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération de l'historique des clôtures", error);
        throw error;
    }
};
export const detailRestaurant = async (restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/restaurant/detail/${restaurantID}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const updateRestaurant = async (restaurantID, restaurantData) => {
    try {
        const response = await apiClient.put(`/v1/restaurant/update/${restaurantID}`, restaurantData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour de la franchise", error);
        throw error;
    }
};
export const toggleRestaurant = async (restaurantID, restaurantData) => {
    try {
        const response = await apiClient.put(`/v1/restaurant/activate/${restaurantID}`, restaurantData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation du compte utilisateur.", error);
        throw error;
    }
};
export const createRestaurant = async (restaurantData) => {
    try {
        const response = await apiClient.post("/v1/restaurant", restaurantData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation d'un restaurant", error);
        throw error;
    }
};
/* --- RESTAURANT INTEGRATIONS --- */
export const getRestaurantIntegrations = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/restaurant-integration/${restaurantId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des intégrations", error);
        throw error;
    }
};
export const updateRestaurantIntegration = async (restaurantId, platform, data) => {
    try {
        const response = await apiClient.patch(`/v1/restaurant-integration/${restaurantId}/${platform}`, data);
        return response.data;
    }
    catch (error) {
        console.error(`Erreur lors de la mise à jour de l'intégration ${platform}`, error);
        throw error;
    }
};
export const testRestaurantIntegration = async (restaurantId, platform) => {
    try {
        const response = await apiClient.post(`/v1/restaurant-integration/${restaurantId}/${platform}/ping`);
        return response.data;
    }
    catch (error) {
        console.error(`Erreur lors du test de l'intégration ${platform}`, error);
        throw error;
    }
};
export const deleteRestaurant = async (restaurantID) => {
    try {
        const response = await apiClient.delete(`/v1/restaurant/delete/${restaurantID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du compte", error);
        throw error;
    }
};
export const uploadRestaurantMenu = async (restaurantID, menuFile) => {
    try {
        const formData = new FormData();
        formData.append('menu', menuFile);
        const response = await apiClientFormData.post(`/v1/restaurant/${restaurantID}/menu`, formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload du menu", error);
        throw error;
    }
};
export const uploadRestaurantImage = async (restaurantID, imageFile) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);
        const response = await apiClientFormData.post(`/v1/restaurant/${restaurantID}/image`, formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload de l'image du restaurant", error);
        throw error;
    }
};
export const createNewOrder = async (orderData) => {
    try {
        const response = await apiClient.post("/initial/order", []);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation d'une commande", error);
        throw error;
    }
};
export const createPOSOrder = async (orderData) => {
    try {
        const response = await apiClient.post("/v1/orders", orderData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la création d'une commande POS", error);
        throw error;
    }
};
export const deleteOrder = async (orderID, reason = "") => {
    try {
        const response = await apiClient.delete(`/v1/orders/${orderID}`, { data: { reason } });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression d'une commande", error);
        throw error;
    }
};
export const permanentDeleteOrder = async (orderID) => {
    try {
        const response = await apiClient.delete(`/v1/orders/${orderID}/permanent`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression définitive d'une commande", error);
        throw error;
    }
};
export const regenerateOrderPdf = async (orderID) => {
    try {
        const response = await apiClient.post(`/v1/orders/${orderID}/regenerate-pdf`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la régénération du PDF", error);
        throw error;
    }
};
export const getCustomers = async (page = 1, restaurantID) => {
    try {
        const response = await apiClient.get(`/v1/customer/all/0/all`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des clients", error);
        throw error;
    }
};
export const getPosClient = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/user/pos-client/${restaurantId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération du client POS", error);
        throw error;
    }
};
export const upsertPosClient = async (restaurantId, data) => {
    try {
        const response = await apiClient.post(`/v1/user/pos-client/${restaurantId}`, data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'enregistrement du client POS", error);
        throw error;
    }
};
export const deletePosClient = async (restaurantId) => {
    try {
        const response = await apiClient.delete(`/v1/user/pos-client/${restaurantId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du client POS", error);
        throw error;
    }
};
export const listeOrder = async (page = 1, limit = 10, search, status) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const role = localStorage.getItem(UserGeneralKey.USER_ROLE);
        const id = role === UserRole.FRANCHISE ? "all" : restaurantID;
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });
        if (search) {
            params.append("search", search);
        }
        if (status) {
            params.append("status", status);
        }
        const response = await apiClient.get(`/v1/restaurants/${id}/orders?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data);
    }
    catch (error) {
        throw error;
    }
};
export const listeOrderByAdmin = async (page = 1, limit = 10, restaurantID, search, status) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });
        if (search) {
            params.append("search", search);
        }
        if (status) {
            params.append("status", status);
        }
        const response = await apiClient.get(`/v1/restaurants/${restaurantID}/orders?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailOrder = async (orderID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/orders/${orderID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const listeMethodePaiement = async (page = 1) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const response = await apiClient.get(`/v1/payment-methods/restaurant/${restaurantID}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const allStatusOrder = async () => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/initial/order/status/all`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const allStatusPaiementOrder = async () => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/initial/order/paiement/status/all`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateOrder = async (orderID, orderData) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.put(`/v1/orders/${orderID}`, orderData);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const listePayment = async (page = 1, limit = "20", search, status, paymentMethod, isArchived) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("limit", limit);
        if (search)
            params.append("search", search);
        if (status)
            params.append("status", status);
        if (paymentMethod)
            params.append("paymentMethod", paymentMethod);
        if (isArchived !== undefined)
            params.append("isArchived", isArchived.toString());
        const response = await apiClient.get(`/v1/transactions?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailPaiement = async (paymentID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/transactions/${paymentID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const createCategorie = async (categorieData) => {
    try {
        const response = await apiClientFormData.post("/v1/category", categorieData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de la categorie", error);
        throw error;
    }
};
export const listeCategorie = async (page = 1, usePagination, restaurantId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("limit", usePagination === "1" ? "10" : "1000");
        if (restaurantId && restaurantId !== "all") {
            params.append("restaurantId", restaurantId);
        }
        const response = await apiClient.get(`/v1/category/all?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const getAllCategories = async (restaurant, page, limit, search) => {
    try {
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (restaurantID)
            params.append("restaurantId", restaurantID);
        const queryString = params.toString();
        const url = queryString
            ? `/v1/category/all?${queryString}`
            : "/v1/category/all";
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des catégories", error);
        throw error;
    }
};
export const getActiveProductsByCategory = async (categoryId, page = 1, limit = 100) => {
    try {
        const response = await apiClient.get(`/v1/product/active/category/${categoryId}?page=${page}&limit=${limit}&locale=fr`);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des produits par catégorie", error);
        throw error;
    }
};
export const getActiveCategories = async (restaurant, page, limit, search) => {
    try {
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (restaurantID)
            params.append("restaurantId", restaurantID);
        const queryString = params.toString();
        const url = queryString
            ? `/v1/category/active?${queryString}`
            : "/v1/category/active";
        const response = await apiClient.get(url);
        const paginatedData = {
            items: response.data.data?.items || response.data.data || [],
            pagination: response.data.data?.pagination || {
                current_page: page || 1,
                total_items: response.data.data?.total || 0,
                total_pages: response.data.data?.totalPages || 1,
                items_per_page: limit || 10,
            }
        };
        return new ApiResponse(response.data.code, response.data.message, paginatedData);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des catégories actives", error);
        throw error;
    }
};
export const getAllProducts = async (restaurant, page, limit, search) => {
    try {
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (restaurantID)
            params.append("restaurantId", restaurantID);
        const queryString = params.toString();
        const url = queryString
            ? `/v1/product/all?${queryString}`
            : "/v1/product/all";
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des produits", error);
        throw error;
    }
};
export const getProductsByCategory = async (categoryId, page, limit, locale, restaurantId) => {
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (locale)
            params.append("locale", locale);
        if (restaurantId)
            params.append("restaurantId", restaurantId);
        const url = `/v1/product/category/${categoryId}?${params.toString()}`;
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des produits par catégorie", error);
        throw error;
    }
};
export const addRestaurantCategorie = async (categorieID) => {
    try {
        const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const response = await apiClient.put(`/v1/restaurant/categorie/addcategorie_restaurant/${restaurantID}/${categorieID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'ajout de restaurant de la categorie", error);
        throw error;
    }
};
export const searchActiveProducts = async (restaurantId, search, page = 1, limit = 100, locale, categoryId) => {
    try {
        const params = new URLSearchParams({
            restaurantId,
            search,
            page: page.toString(),
            limit: limit.toString(),
        });
        if (locale)
            params.append("locale", locale);
        if (categoryId)
            params.append("categoryId", categoryId);
        const response = await apiClient.get(`/v1/product/active/search?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la recherche des produits actifs", error);
        throw error;
    }
};
export const listeRestaurantCategorie = async (page = 1, usePagination, restaurant, search) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const limit = usePagination === "1" ? "10" : "1000";
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const params = new URLSearchParams({
            page: page.toString(),
            limit,
        });
        if (search)
            params.append("search", search);
        if (restaurantID)
            params.append("restaurantId", restaurantID);
        const response = await apiClient.get(`/v1/category/all?${params.toString()}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const toggleActivationCategorieRestaurant = async (categorieID, isActive) => {
    try {
        const response = await apiClient.put(`/v1/category/activate/${categorieID}`, { isActive: isActive });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de la categorie.", error);
        throw error;
    }
};
export const deleteRestaurantCategorie = async (restaurantCategorieID) => {
    try {
        const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const response = await apiClient.delete(`/v1/category/${restaurantCategorieID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression de la catégorie", error);
        throw error;
    }
};
export const listeRestaurantProduct = async (page = 1, usePagination, categoryId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const path = [
            `/restaurant/products/${restaurantID}/0/${usePagination}`,
            categoryId,
        ]
            .filter(Boolean)
            .join("/");
        const url = `${path}?page=${page}`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const toggleActivationProductRestaurant = async (productID, isActive) => {
    try {
        const response = await apiClient.put(`/v1/product/activate/${productID}`, { isActive: isActive });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation du produit.", error);
        throw error;
    }
};
export const listeCategorieActive = async (page = 1, usePagination, restaurantId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("limit", usePagination === "1" ? "10" : "1000");
        if (restaurantId && restaurantId !== "all") {
            params.append("restaurantId", restaurantId);
        }
        const response = await apiClient.get(`/v1/category/active?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailCategorie = async (categorieID, restaurant) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const restaurantID = restaurant
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        const queryString = restaurantID
            ? `?restaurantId=${encodeURIComponent(restaurantID)}`
            : "";
        const response = await apiClient.get(`/v1/category/${categorieID}${queryString}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateCategorie = async (categorieID, categorieData) => {
    try {
        const response = await apiClientFormData.put(`/v1/category/${categorieID}`, categorieData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de la categorie", error);
        throw error;
    }
};
export const deleteCategorie = async (categorieID) => {
    try {
        const response = await apiClient.delete(`/v1/category/delete/temporary/${categorieID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression de la categorie", error);
        throw error;
    }
};
export const deleteProgramme = async (programmeID) => {
    try {
        const response = await apiClient.delete(`/v1/programme/${programmeID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du programme", error);
        throw error;
    }
};
export const createOrUpdateTimeSlotConfig = async (configData) => {
    try {
        const response = await apiClient.post("/delivery-slot/config", configData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la création/mise à jour du créneau", error);
        throw error;
    }
};
export const getTimeSlotConfig = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/delivery-slot/config/${restaurantId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération du créneau", error);
        throw error;
    }
};
export const createTimeSlot = createOrUpdateTimeSlotConfig;
export const updateTimeSlot = createOrUpdateTimeSlotConfig;
export const detailTimeSlot = getTimeSlotConfig;
export const listeTimeSlot = async (page = 1, restaurantID) => {
    if (restaurantID) {
        return getTimeSlotConfig(restaurantID);
    }
    return new ApiResponse(200, "Success", null);
};
export const deleteTimeSlot = async (restaurantID) => {
    try {
        const response = await apiClient.delete(`/delivery-slot/config/${restaurantID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du créneau", error);
        throw error;
    }
};
export const toggleActivationCategorie = async (categorieID, categorieData) => {
    try {
        const response = await apiClient.put(`/v1/category/activate/${categorieID}`, categorieData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de la categorie.", error);
        throw error;
    }
};
export const createIngredient = async (ingredientData) => {
    try {
        const client = ingredientData instanceof FormData ? apiClientFormData : apiClient;
        let dataToSend = ingredientData;
        if (ingredientData instanceof FormData) {
            if (!ingredientData.has("restaurantId")) {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || "";
                if (restaurantID) {
                    ingredientData.append("restaurantId", restaurantID);
                }
            }
            dataToSend = ingredientData;
        }
        else {
            const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || "";
            if (restaurantID && !ingredientData.restaurantId) {
                dataToSend = { ...ingredientData, restaurantId: restaurantID };
            }
        }
        const response = await client.post("/v1/ingredient", dataToSend);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de ingredient", error);
        throw error;
    }
};
export const listeIngredient = async (page = 1, restaurantId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("limit", "1000"); // Retrieve all ingredients for selection lists
        let finalRestaurantId = restaurantId;
        if (!finalRestaurantId || finalRestaurantId === '1') {
            finalRestaurantId = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || "";
        }
        if (finalRestaurantId) {
            params.append("restaurantId", finalRestaurantId);
        }
        const response = await apiClient.get(`/v1/ingredient/all?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailIngredient = async (ingredientID, locale, restaurant) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        if (locale)
            params.append("locale", locale);
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
        if (restaurantID && restaurantID !== "null") {
            params.append("restaurantId", restaurantID);
        }
        const query = params.toString();
        const url = `/v1/ingredient/${ingredientID}`;
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateIngredient = async (ingredientID, ingredientData) => {
    try {
        const client = ingredientData instanceof FormData ? apiClientFormData : apiClient;
        let dataToSend = ingredientData;
        if (ingredientData instanceof FormData) {
            if (!ingredientData.has("restaurantId")) {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || "";
                if (restaurantID) {
                    ingredientData.append("restaurantId", restaurantID);
                }
            }
            dataToSend = ingredientData;
        }
        else {
            const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || "";
            if (restaurantID && !ingredientData.restaurantId) {
                dataToSend = { ...ingredientData, restaurantId: restaurantID };
            }
        }
        const response = await client.put(`/v1/ingredient/${ingredientID}`, dataToSend);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour d'ingredient", error);
        throw error;
    }
};
export const updateVariationIngredient = async (ingredientID, varationData) => {
    try {
        const response = await apiClient.put(`/v1/add/ingredient/variation/update/${ingredientID}`, varationData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour de la variation ingredient", error);
        throw error;
    }
};
export const deleteIngredientVariation = async (ingredientID, variationID) => {
    try {
        const response = await apiClient.delete(`/v1/add/ingredient/variation/delete/${ingredientID}/${variationID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression de variation ingredient", error);
        throw error;
    }
};
export const deleteIngredient = async (ingredientID) => {
    try {
        const response = await apiClient.delete(`/v1/ingredient/${ingredientID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression ingredient", error);
        throw error;
    }
};
export const toggleActivationIngredient = async (ingredientID, ingredientData) => {
    try {
        const response = await apiClient.put(`/v1/ingredient/activate/${ingredientID}`, ingredientData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de ingredient.", error);
        throw error;
    }
};
export const duplicateIngredient = async (ingredientID, restaurantId) => {
    try {
        const url = `/v1/ingredient/${ingredientID}/duplicate?restaurantId=${encodeURIComponent(restaurantId)}`;
        const response = await apiClient.post(url);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la duplication de l'ingrédient", error);
        throw error;
    }
};
export const createProduct = async (productData, formData) => {
    try {
        const client = formData ? apiClientFormData : apiClient;
        const data = formData || productData;
        const response = await client.post("/v1/product", data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de produit", error);
        throw error;
    }
};
export const listeProducts = async (page = 1, usePagination, filter, filterData) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.post(`/product/filter/${filter}/${usePagination}?page=${page}`, filterData);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const detailProduct = async (productID, locale) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/product/${productID}?locale=${locale}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateProduct = async (productID, productData, formData) => {
    try {
        const client = formData ? apiClientFormData : apiClient;
        const data = formData || productData;
        const response = await client.put(`/v1/product/${productID}`, data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour du produit", error);
        throw error;
    }
};
export const setProductAsFeatured = async (productId, isVedette) => {
    try {
        const response = await apiClient.put("/v1/product/featured/updated", {
            productId,
            isVedette,
        });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise en vedette du produit", error);
        throw error;
    }
};
export const updateVariationProduct = async (productID, varationData) => {
    try {
        const response = await apiClient.put(`/v1/product/variation/update/${productID}`, varationData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise a jour de la variation produit", error);
        throw error;
    }
};
export const removeVariationProduct = async (productID, variationID) => {
    try {
        const response = await apiClient.delete(`/v1/product/variation/delete/${productID}/${variationID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression de la variation du produit", error);
        throw error;
    }
};
export const toggleActivationProduct = async (productID, isActive) => {
    try {
        const response = await apiClient.put(`/v1/product/activate/${productID}`, { isActive: isActive });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de ingredient.", error);
        throw error;
    }
};
export const setProductAsStela = async (productId, isStela) => {
    try {
        const response = await apiClient.put("/v1/product/stela/updated", {
            productId,
            isStela,
        });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour du statut stela du produit", error);
        throw error;
    }
};
export const toggleActivationFeatureProduct = async (productID, productData) => {
    try {
        const response = await apiClient.put(`/v1/product/state/toggle/${productID}`, productData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation de ingredient.", error);
        throw error;
    }
};
export const deleteProductTemporary = async (productID) => {
    try {
        const response = await apiClient.delete(`/v1/product/${productID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du produit", error);
        throw error;
    }
};
export const reportVenteAdmin = async (restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = [`/statistics/restaurant`, restaurantID]
            .filter(Boolean)
            .join("/");
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const reportVenteRestaurant = async (restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/statistics/restaurant/${restaurantID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const reportRestaurants = async (restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/statistics/restaurants`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const salesReportRestaurants = async () => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/statistics/sales-report`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const reportPeriodiqueCard = async (restaurantID, filters) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `/periodique_report`;
        const defaultFilters = {
            paymentMethod: "all",
            orderType: "all",
            startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                .toISOString()
                .split("T")[0],
            endDate: new Date().toISOString().split("T")[0],
        };
        const finalFilters = filters || defaultFilters;
        const queryParams = new URLSearchParams();
        if (restaurantID) {
            queryParams.append("restaurantId", restaurantID);
        }
        if (finalFilters.paymentMethod && finalFilters.paymentMethod !== "all") {
            queryParams.append("paymentMethod", finalFilters.paymentMethod);
        }
        if (finalFilters.orderType && finalFilters.orderType !== "all") {
            queryParams.append("orderType", finalFilters.orderType);
        }
        if (finalFilters.startDate) {
            queryParams.append("startDate", finalFilters.startDate);
        }
        if (finalFilters.endDate) {
            queryParams.append("endDate", finalFilters.endDate);
        }
        const fullUrl = queryParams.toString()
            ? `${url}?${queryParams.toString()}`
            : url;
        const response = await apiClient.get(fullUrl);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const reportPeriodiqueCardById = async (restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/initial/order/periodique_report/${restaurantID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const getOrdersByStatusStats = async (filters) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `/statistics/orders-by-status`;
        const queryParams = new URLSearchParams();
        if (filters?.restaurantId)
            queryParams.append("restaurantId", filters.restaurantId);
        if (filters?.startDate)
            queryParams.append("startDate", filters.startDate);
        if (filters?.endDate)
            queryParams.append("endDate", filters.endDate);
        if (filters?.orderStatus && filters.orderStatus !== "all") {
            queryParams.append("orderStatus", filters.orderStatus);
        }
        if (filters?.paymentStatus && filters.paymentStatus !== "all") {
            queryParams.append("paymentStatus", filters.paymentStatus);
        }
        if (filters?.startTime) {
            queryParams.append("startTime", filters.startTime);
        }
        if (filters?.endTime) {
            queryParams.append("endTime", filters.endTime);
        }
        const fullUrl = queryParams.toString()
            ? `${url}?${queryParams.toString()}`
            : url;
        const response = await apiClient.get(fullUrl);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const getAverageBasketStats = async (filters) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `/statistics/average-basket`;
        const queryParams = new URLSearchParams();
        if (filters?.restaurantId)
            queryParams.append("restaurantId", filters.restaurantId);
        if (filters?.startDate)
            queryParams.append("startDate", filters.startDate);
        if (filters?.endDate)
            queryParams.append("endDate", filters.endDate);
        if (filters?.orderType && filters.orderType !== "all")
            queryParams.append("orderType", filters.orderType);
        if (filters?.paymentMethod && filters.paymentMethod !== "all")
            queryParams.append("paymentMethod", filters.paymentMethod);
        if (filters?.orderStatus && filters.orderStatus !== "all") {
            queryParams.append("orderStatus", filters.orderStatus);
        }
        if (filters?.paymentStatus && filters.paymentStatus !== "all") {
            queryParams.append("paymentStatus", filters.paymentStatus);
        }
        if (filters?.startTime) {
            queryParams.append("startTime", filters.startTime);
        }
        if (filters?.endTime) {
            queryParams.append("endTime", filters.endTime);
        }
        const fullUrl = queryParams.toString()
            ? `${url}?${queryParams.toString()}`
            : url;
        const response = await apiClient.get(fullUrl);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const getTotalAmount = async (restaurantID, filters) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = `/statistics/total-amount`;
        const queryParams = new URLSearchParams();
        if (restaurantID) {
            queryParams.append("restaurantId", restaurantID);
        }
        if (filters?.paymentMethod && filters.paymentMethod !== "all") {
            queryParams.append("paymentMethod", filters.paymentMethod);
        }
        if (filters?.orderType && filters.orderType !== "all") {
            queryParams.append("orderType", filters.orderType);
        }
        if (filters?.startDate) {
            queryParams.append("startDate", filters.startDate);
        }
        if (filters?.endDate) {
            queryParams.append("endDate", filters.endDate);
        }
        if (filters?.startTime) {
            queryParams.append("startTime", filters.startTime);
        }
        if (filters?.endTime) {
            queryParams.append("endTime", filters.endTime);
        }
        const fullUrl = queryParams.toString()
            ? `${url}?${queryParams.toString()}`
            : url;
        const response = await apiClient.get(fullUrl);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const createCampagne = async (campagneData) => {
    try {
        const response = await apiClient.post("/v1/campaigns", campagneData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de campagne", error);
        throw error;
    }
};
export const listeCampagne = async (page = 1, limit = 10, search = "") => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.get(`/campaigns/${franchiseId}`);
    return {
        code: 200,
        message: "Success",
        data: response.data,
        pagination: { total: response.data.length, page: 1, limit: 100, totalPages: 1 }
    };
};
export const detailCampagne = async (campagneID) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.get(`/campaigns/${franchiseId}/${campagneID}`);
    return {
        code: 200,
        message: "Success",
        data: response.data
    };
};
export const deleteCampagne = async (campagneID) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.delete(`/campaigns/${franchiseId}/${campagneID}`);
    return {
        code: 200,
        message: "Supprimé avec succès",
        data: response.data
    };
};
export const createMarketingCampaign = async (data) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.post(`/campaigns/${franchiseId}`, data);
    return {
        code: 201,
        message: "Campagne créée avec succès",
        data: response.data
    };
};
export const getMarketingConfig = async () => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.get(`/settings/${franchiseId}`);
    return {
        code: 200,
        message: "Success",
        data: response.data
    };
};
export const updateMarketingConfig = async (data) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.post(`/settings/${franchiseId}`, data);
    return {
        code: 200,
        message: "Configuration marketing mise à jour",
        data: response.data
    };
};
export const updateMarketingCampaign = async (campaignId, data) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.post(`/campaigns/${franchiseId}/${campaignId}`, data);
    return {
        code: 200,
        message: "Campagne mise à jour avec succès",
        data: response.data
    };
};
export const sendMarketingCampaign = async (campaignId) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.post(`/campaigns/${franchiseId}/${campaignId}/send`);
    return {
        code: 200,
        message: "Campagne lancée avec succès",
        data: response.data
    };
};
export const getMarketingCampaignReport = async (campaignId) => {
    const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
    const response = await marketingApiClient.get(`/campaigns/${franchiseId}/${campaignId}/report`);
    return {
        code: 200,
        message: "Rapport récupéré avec succès",
        data: response.data
    };
};
export const createNotification = async (notificationData) => {
    try {
        const response = await apiClient.post("/v1/push-notifications", notificationData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de notification", error);
        throw error;
    }
};
export const listeNotification = async (page = 1, limit = 10, search = "", status = "") => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        if (status)
            params.append("status", status);
        const response = await apiClient.get(`/v1/push-notifications?${params.toString()}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data, response.data.pagination);
    }
    catch (error) {
        throw error;
    }
};
export const generateCouponCode = async (prefix, mode, type) => {
    try {
        const params = new URLSearchParams();
        if (prefix)
            params.append('prefix', prefix);
        if (mode)
            params.append('mode', mode);
        if (type)
            params.append('type', type);
        const url = `/coupons/generate-code?${params.toString()}`;
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la génération du code coupon", error);
        throw error;
    }
};
export const createCoupon = async (couponData) => {
    try {
        const response = await apiClient.post("/coupons", couponData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation du coupon", error);
        throw error;
    }
};
export const disableCoupon = async (code, couponData) => {
    try {
        const response = await apiClient.put(`/v1/coupon/order/disable/${code}`, couponData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la desactivation du coupon", error);
        throw error;
    }
};
export const detailCoupon = async (couponID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/coupons/details/${couponID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateCoupon = async (couponId, couponData) => {
    try {
        const response = await apiClient.patch(`/coupons/update/${couponId}`, couponData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de la categorie", error);
        throw error;
    }
};
export const listeCoupon = async (page = 1) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/coupons?page=${page}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data, response.data.pagination);
    }
    catch (error) {
        throw error;
    }
};
export const deleteCoupon = async (couponID) => {
    try {
        const response = await apiClient.delete(`/coupons/remove/${couponID}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du coupon", error);
        throw error;
    }
};
export const claimCouponByTemplate = async (templateId, email) => {
    try {
        const response = await apiClient.post(`/coupons/claim`, {
            templateId,
            email,
        });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la génération du coupon", error);
        throw error;
    }
};
export const listeProgramme = async (page = 1, restaurantId) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        if (restaurantId) {
            params.append('restaurantId', restaurantId);
        }
        const queryString = params.toString();
        const url = queryString ? `/v1/programme/all?${queryString}` : `/v1/programme/all`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data, response.data.pagination);
    }
    catch (error) {
        throw error;
    }
};
export const getAdminReferralList = async (params) => {
    try {
        const queryParams = new URLSearchParams();
        if (params.restaurantId)
            queryParams.append("restaurantId", params.restaurantId);
        if (params.startDate)
            queryParams.append("startDate", params.startDate);
        if (params.endDate)
            queryParams.append("endDate", params.endDate);
        if (params.search)
            queryParams.append("search", params.search);
        if (params.page)
            queryParams.append("page", params.page.toString());
        if (params.limit)
            queryParams.append("limit", params.limit.toString());
        const response = await apiClient.get(`/v1/parrainage/admin/referrals?${queryParams.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération du rapport de parrainage", error);
        throw error;
    }
};
export const getAdminTopReferrers = async (params) => {
    try {
        const queryParams = new URLSearchParams();
        if (params.restaurantId)
            queryParams.append("restaurantId", params.restaurantId);
        if (params.startDate)
            queryParams.append("startDate", params.startDate);
        if (params.endDate)
            queryParams.append("endDate", params.endDate);
        if (params.limit)
            queryParams.append("limit", params.limit.toString());
        const response = await apiClient.get(`/v1/parrainage/admin/top-referrers?${queryParams.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération du classement parrainage", error);
        throw error;
    }
};
export const detailProgramme = async (programmeID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/programme/${programmeID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const updateProgramme = async (programmeID, programmeData) => {
    try {
        const response = await apiClient.put(`/v1/programme/${programmeID}`, programmeData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la creation de la categorie", error);
        throw error;
    }
};
export const toggleActivationProgramme = async (programmeData) => {
    try {
        const response = await apiClient.put(`/v1/programme/active`, programmeData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du toggle activation du programme.", error);
        throw error;
    }
};
export const detailNotification = async (notificationID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/push-notifications/${notificationID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const sendPushNotification = async (notificationID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.post(`/v1/push-notifications/${notificationID}/send`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const deleteNotification = async (notificationID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.delete(`/v1/push-notifications/${notificationID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const getAllCustomers = async (page, limit, search, searchPhone) => {
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        if (searchPhone)
            params.append("searchPhone", searchPhone);
        const url = `/v1/customers/all?${params.toString()}`;
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des clients", error);
        throw error;
    }
};
export const getCustomersWithPromotionsOrNewsletter = async (page, limit, restaurantId, search) => {
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (restaurantId)
            params.append("restaurantId", restaurantId);
        if (search)
            params.append("search", search);
        const url = `/v1/users/promotions-newsletter?${params.toString()}`;
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des clients", error);
        throw error;
    }
};
export const detailCustomer = async (customerID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const response = await apiClient.get(`/v1/customer/detail/${customerID}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const createUserAddress = async (addressData) => {
    try {
        const response = await apiClient.post(`/v1/user/addresses/`, addressData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la création de l'adresse.", error);
        throw error;
    }
};
export const printTicketLocally = async (pdfFile) => {
    try {
        const formData = new FormData();
        formData.append("fichier", pdfFile);
        const response = (await fetch("http://localhost:8080/print.php", {
            method: "POST",
            body: formData,
        }));
        return response;
    }
    catch (error) {
        console.error("Erreur lors de l'envoi du PDF", error);
        throw error;
    }
};
export const topProductReportSell = async (categoryID, restaurantID, startDate, endDate, startTime, endTime, orderType, paymentMethod) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const params = new URLSearchParams();
        if (categoryID)
            params.append("categoryId", categoryID);
        if (restaurantID && restaurantID !== 'all')
            params.append("restaurantId", restaurantID);
        if (startDate)
            params.append("startDate", startDate);
        if (endDate)
            params.append("endDate", endDate);
        if (startTime)
            params.append("startTime", startTime);
        if (endTime)
            params.append("endTime", endTime);
        if (orderType)
            params.append("orderType", orderType);
        if (paymentMethod)
            params.append("paymentMethod", paymentMethod);
        const url = `/statistics/category-product-report?${params.toString()}`;
        const response = await apiClient.get(url);
        // Mapper le format attendue par le frontend {name, total_sales}
        // Le backend renvoie { byProduct: [ { productId, productName, total, ... } ] }
        const mappedData = (response.data?.data?.byProduct || []).map((p) => ({
            name: p.productName,
            total_sales: p.totalAmount || 0
        }));
        return new ApiResponse(response.data.code, response.data.message, mappedData);
    }
    catch (error) {
        console.error("❌ Erreur dans topProductReportSell:", error);
        throw error;
    }
};
export const getProductSingleReport = async (restaurantId, productId, startDate, endDate, startTime, endTime, orderType, paymentMethod) => {
    try {
        const params = new URLSearchParams();
        params.append("restaurantId", restaurantId);
        if (productId)
            params.append("productId", productId);
        if (startDate)
            params.append("startDate", startDate);
        if (endDate)
            params.append("endDate", endDate);
        if (startTime)
            params.append("startTime", startTime);
        if (endTime)
            params.append("endTime", endTime);
        if (orderType)
            params.append("orderType", orderType);
        if (paymentMethod)
            params.append("paymentMethod", paymentMethod);
        const url = `/statistics/category-product-report?${params.toString()}`;
        const response = await apiClient.get(url);
        // Extraire les données du produit spécifique
        const productData = (response.data?.data?.byProduct || []).find((p) => p.productId === productId);
        return new ApiResponse(response.data.code, response.data.message, productData || { totalAmount: 0, orderCount: 0, quantity: 0 });
    }
    catch (error) {
        console.error("❌ Erreur dans getProductSingleReport:", error);
        throw error;
    }
};
export const tauxCommandeCategorie = async (categoryID, startDate, endDate, restaurantID, paymentMethode, orderType) => {
    const cleanStartDate = startDate.replace(/\s/g, "-").replace(/:\d{2}$/, "");
    const cleanEndDate = endDate.replace(/\s/g, "-").replace(/:\d{2}$/, "");
    const url = `/v1/report_sale/tauxcommande/${categoryID}/${cleanStartDate}/${cleanEndDate}/${restaurantID}/${paymentMethode}/${orderType}`;
    const response = await apiClient.get(url);
    return new ApiResponse(response.data.code, response.data.message, response.data.data);
};
/* eslint-disable */
export const nombreCommandeParProduct = async (_productID, startDate, endDate, restaurantID, paymentMethode, orderType, deliveryType = "all") => {
    try {
        const encodedStartDate = encodeURIComponent(startDate.trim());
        const encodedEndDate = encodeURIComponent(endDate.trim());
        const encodedOrderType = encodeURIComponent(orderType || "all");
        const encodedPaymentMethod = encodeURIComponent(paymentMethode || "all");
        const encodedDeliveryType = encodeURIComponent(deliveryType || "all");
        const url = `/report_sale/${restaurantID}/${encodedStartDate}/${encodedEndDate}/${encodedOrderType}/${encodedPaymentMethod}/${encodedDeliveryType}`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const averageReportSellByCategory = async (restaurantId, categoryId, productId, startDate, endDate, startTime, endTime) => {
    try {
        const params = new URLSearchParams();
        params.append("restaurantId", restaurantId);
        if (categoryId)
            params.append("categoryId", categoryId);
        if (productId)
            params.append("productId", productId);
        if (startDate)
            params.append("startDate", startDate);
        if (endDate)
            params.append("endDate", endDate);
        if (startTime)
            params.append("startTime", startTime);
        if (endTime)
            params.append("endTime", endTime);
        const url = `/statistics/category-product-report?${params.toString()}`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const averageReportSell = async (productID, restaurantID) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const url = [`/v1/report_sale/average/${productID}`, restaurantID]
            .filter(Boolean)
            .join("/");
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const uploadFile = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await apiClientFormData.post("/v1/upload", formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload du fichier", error);
        throw error;
    }
};
export const uploadCmsMedia = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await apiClientFormData.post("/v1/cms/media/upload", formData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload CMS media", error);
        throw error;
    }
};
export const deleteFileUpload = async (public_idData) => {
    try {
        const response = await apiClient.delete(`/v1/upload/delete/${public_idData}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du fichier uploader", error);
        throw error;
    }
};
export const calculateMinimumAmount = async (codePostal, localite, restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/zone/calculate-minimum-amount?codePostal=${codePostal}&localite=${localite}&restaurantId=${restaurantId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors du calcul du minimum de commande", error);
        throw error;
    }
};
// ----------------------------------------------------------------------
// FEATURES
// ----------------------------------------------------------------------
export const getAllFeatures = async (page = 1, limit = 10, search, locale) => {
    try {
        let url = `/v1/feature/all?page=${page}&limit=${limit}`;
        if (search) {
            url += `&search=${search}`;
        }
        if (locale) {
            url += `&locale=${locale}`;
        }
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des features", error);
        throw error;
    }
};
export const getFeatureById = async (id, locale) => {
    try {
        let url = `/v1/feature/${id}`;
        if (locale) {
            url += `?locale=${locale}`;
        }
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération du feature", error);
        throw error;
    }
};
export const createFeature = async (featureData) => {
    try {
        const response = await apiClient.post("/v1/feature", featureData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la création du feature", error);
        throw error;
    }
};
export const updateFeature = async (id, featureData) => {
    try {
        const response = await apiClient.put(`/v1/feature/${id}`, featureData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour du feature", error);
        throw error;
    }
};
export const deleteFeature = async (id) => {
    try {
        const response = await apiClient.delete(`/v1/feature/${id}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression du feature", error);
        throw error;
    }
};
export const updateFeatureTranslation = async (id, locale, name) => {
    try {
        const response = await apiClient.put(`/v1/feature/${id}/translations/${locale}`, { name });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour de la traduction", error);
        throw error;
    }
};
/* eslint-disable */
export const listeIngredientBase = async (page = 1, limit = 10, search, locale) => {
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        if (locale)
            params.append("locale", locale);
        const url = `/v1/ingredient-base/all?${params.toString()}`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data, response.data.pagination);
    }
    catch (error) {
        throw error;
    }
};
export const detailIngredientBase = async (ingredientBaseID, locale) => {
    try {
        const params = new URLSearchParams();
        if (locale)
            params.append("locale", locale);
        const query = params.toString();
        const url = query
            ? `/v1/ingredient-base/${ingredientBaseID}?${query}`
            : `/v1/ingredient-base/${ingredientBaseID}`;
        const response = await apiClient.get(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const createIngredientBase = async (payload) => {
    try {
        const url = `/v1/ingredient-base`;
        const response = await apiClient.post(url, payload);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const updateIngredientBase = async (ingredientBaseID, payload) => {
    try {
        const url = `/v1/ingredient-base/${ingredientBaseID}`;
        const response = await apiClient.put(url, payload);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const deleteIngredientBase = async (ingredientBaseID) => {
    try {
        const url = `/v1/ingredient-base/${ingredientBaseID}`;
        const response = await apiClient.delete(url);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const updateIngredientBaseTranslation = async (ingredientBaseID, locale, payload) => {
    try {
        const url = `/v1/ingredient-base/${ingredientBaseID}/translations/${locale}`;
        const response = await apiClient.put(url, payload);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        throw error;
    }
};
export const getAllIngredients = async (page, limit, search, type, locale, restaurant, isRecommended) => {
    try {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (limit)
            params.append("limit", limit.toString());
        if (search)
            params.append("search", search);
        if (type)
            params.append("type", type);
        if (locale)
            params.append("locale", locale);
        const isAdmin = localStorage.getItem(UserGeneralKey.USER_ROLE) === UserRole.FRANCHISE;
        const restaurantID = isAdmin
            ? restaurant
            : localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID) || restaurant;
        if (restaurantID && restaurantID !== "null") {
            params.append("restaurantId", restaurantID);
        }
        if (isRecommended !== undefined) {
            params.append("is_recommended", isRecommended.toString());
        }
        const url = `/v1/ingredient/all?${params.toString()}`;
        const response = await apiClient.get(url);
        const result = new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
        return result;
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des ingrédients", error);
        throw error;
    }
};
export const getIngredientTypes = async (locale) => {
    try {
        const params = locale ? { locale } : {};
        const response = await apiClient.get(`/v1/ingredients/types`, { params });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des types d'ingrédients", error);
        throw error;
    }
};
export const updateIngredientTypePosition = async (type, position) => {
    try {
        const response = await apiClient.put(`/v1/ingredients/types/position`, {
            type,
            position,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la position du type", error);
        throw error;
    }
};
export const createOrUpdateIngredientType = async (type, position, translations) => {
    try {
        const body = {
            type,
        };
        if (position !== undefined) {
            body.position = position;
        }
        if (translations && translations.length > 0) {
            body.translations = translations;
        }
        const response = await apiClient.post(`/v1/ingredients/types`, body);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la création/mise à jour du type d'ingrédient", error);
        throw error;
    }
};
export const updateIngredientTypeTranslation = async (typeId, locale, name) => {
    try {
        const response = await apiClient.put(`/v1/ingredients/types/${typeId}/translations/${locale}`, { name });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la traduction du type d'ingrédient", error);
        throw error;
    }
};
export const deleteIngredientType = async (type) => {
    try {
        const response = await apiClient.delete(`/v1/ingredients/types/${type}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression du type d'ingrédient", error);
        throw error;
    }
};
export const getDeliveryZonesByRestaurant = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/delivery/restaurant/${restaurantId}/zones`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des zones de livraison", error);
        throw error;
    }
};
export const getDeliveryZoneById = async (zoneId) => {
    try {
        const response = await apiClient.get(`/v1/delivery/zone/${zoneId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération de la zone de livraison", error);
        throw error;
    }
};
export const createDeliveryZone = async (restaurantId, zoneData) => {
    try {
        const response = await apiClient.post(`/v1/delivery/zone/${restaurantId}`, zoneData);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la création de la zone de livraison", error);
        throw error;
    }
};
export const updateDeliveryZone = async (zoneId, updateData) => {
    try {
        const response = await apiClient.put(`/v1/delivery/zone/${zoneId}`, updateData);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la zone de livraison", error);
        throw error;
    }
};
export const deleteDeliveryZone = async (zoneId) => {
    try {
        const response = await apiClient.delete(`/v1/delivery/zone/${zoneId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression de la zone de livraison", error);
        throw error;
    }
};
export const addPostalCodesToZone = async (zoneId, postalCodes) => {
    try {
        const response = await apiClient.post(`/v1/delivery/zone/${zoneId}/postal-codes`, postalCodes);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de l'ajout des codes postaux", error);
        throw error;
    }
};
export const getPostalCodesByZone = async (zoneId) => {
    try {
        const response = await apiClient.get(`/v1/delivery/zone/${zoneId}/postal-codes`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des codes postaux", error);
        throw error;
    }
};
export const deletePostalCodeFromZone = async (zoneId, postalCode) => {
    try {
        const response = await apiClient.delete(`/v1/delivery/zone/${zoneId}/postal-codes/${postalCode}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression du code postal", error);
        throw error;
    }
};
export const updatePostalCodeInZone = async (zoneId, postalCode, updateData) => {
    try {
        const response = await apiClient.put(`/v1/delivery/zone/${zoneId}/postal-codes/${postalCode}`, updateData);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la modification du code postal", error);
        throw error;
    }
};
export const getRestaurantPostalCodes = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/delivery/restaurant/${restaurantId}/postal-codes`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des codes postaux du restaurant", error);
        throw error;
    }
};
export const getOpeningDaysByRestaurant = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/opening-days/restaurant/${restaurantId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des jours d'ouverture", error);
        throw error;
    }
};
export const createBulkOpeningDays = async (restaurantId, days) => {
    try {
        const response = await apiClient.post(`/v1/opening-days/bulk`, {
            restaurantId,
            days,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la création des jours d'ouverture", error);
        throw error;
    }
};
export const deleteOpeningDay = async (dayId) => {
    try {
        const response = await apiClient.delete(`/v1/opening-days/${dayId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression du jour d'ouverture", error);
        throw error;
    }
};
export const getOpeningHoursByRestaurant = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/opening-hours/restaurant/${restaurantId}/formatted`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des horaires d'ouverture", error);
        throw error;
    }
};
export const createBulkOpeningHours = async (restaurantId, schedules) => {
    try {
        const response = await apiClient.post(`/v1/opening-hours/bulk`, {
            restaurantId,
            schedules,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la création des horaires d'ouverture", error);
        throw error;
    }
};
export const getDetailedOpeningHours = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/opening-hours/restaurant/${restaurantId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des horaires détaillés", error);
        throw error;
    }
};
export const deleteOpeningHour = async (hourId) => {
    try {
        const response = await apiClient.delete(`/v1/opening-hours/${hourId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression de l'horaire", error);
        throw error;
    }
};
export const getPaymentMethodsForRestaurant = async (restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/payment-methods/restaurant/${restaurantId}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des moyens de paiement", error);
        throw error;
    }
};
export const setPaymentMethodStatus = async (restaurantId, paymentMethod, enabled) => {
    try {
        const response = await apiClient.put(`/v1/payment-methods/restaurant/${restaurantId}`, {
            paymentMethod,
            enabled,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la configuration du moyen de paiement", error);
        throw error;
    }
};
export const setPaymentMethodsStatusBatch = async (restaurantId, paymentMethods) => {
    try {
        const response = await apiClient.post(`/v1/payment-methods/restaurant/${restaurantId}/batch`, {
            paymentMethods,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la configuration en lot des moyens de paiement", error);
        throw error;
    }
};
export const getAllSupplements = async (page, limit, search, type, locale) => {
    try {
        const params = {};
        if (page)
            params.page = page;
        if (limit)
            params.limit = limit;
        if (search)
            params.search = search;
        if (type)
            params.type = type;
        if (locale)
            params.locale = locale;
        const response = await apiClient.get(`/v1/supplement/all`, { params });
        return new ApiResponse(response.data.code, response.data.message, {
            data: response.data.data,
            pagination: response.data.pagination,
        });
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des suppléments", error);
        throw error;
    }
};
export const getSupplementById = async (supplementId, locale) => {
    try {
        const params = locale ? { locale } : {};
        const response = await apiClient.get(`/v1/supplement/${supplementId}`, { params });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération du supplément", error);
        throw error;
    }
};
export const createSupplement = async (supplementData) => {
    try {
        const client = supplementData instanceof FormData ? apiClientFormData : apiClient;
        const response = await client.post("/v1/supplement", supplementData);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur lors de la création du supplément", error);
        throw error;
    }
};
export const updateSupplement = async (supplementId, supplementData) => {
    try {
        const client = supplementData instanceof FormData ? apiClientFormData : apiClient;
        const response = await client.put(`/v1/supplement/${supplementId}`, supplementData);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour du supplément", error);
        throw error;
    }
};
export const toggleActivationSupplement = async (supplementId, supplementData) => {
    try {
        const response = await apiClient.put(`/v1/supplement/activate/${supplementId}`, supplementData);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur lors de l'activation/désactivation du supplément", error);
        throw error;
    }
};
export const deleteSupplement = async (supplementId) => {
    try {
        const response = await apiClient.delete(`/v1/supplement/${supplementId}`);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression du supplément", error);
        throw error;
    }
};
export const getSupplementTypes = async (locale) => {
    try {
        const params = locale ? { locale } : {};
        const response = await apiClient.get(`/v1/supplements/types`, { params });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la récupération des types de suppléments", error);
        throw error;
    }
};
export const createOrUpdateSupplementType = async (type, position, translations) => {
    try {
        const payload = { type };
        if (position !== undefined)
            payload.position = position;
        if (translations && translations.length > 0) {
            payload.translations = translations;
        }
        const response = await apiClient.post(`/v1/supplements/types`, payload);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la création/mise à jour du type de supplément", error);
        throw error;
    }
};
export const updateSupplementTypePosition = async (type, position) => {
    try {
        const response = await apiClient.put(`/v1/supplements/types/position`, {
            type,
            position,
        });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la position du type de supplément", error);
        throw error;
    }
};
export const updateSupplementTypeTranslation = async (typeId, locale, name) => {
    try {
        const response = await apiClient.put(`/v1/supplements/types/${typeId}/translations/${locale}`, { name });
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la mise à jour de la traduction du type de supplément", error);
        throw error;
    }
};
export const deleteSupplementType = async (type) => {
    try {
        const response = await apiClient.delete(`/v1/supplements/types/${type}`);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de la suppression du type de supplément", error);
        throw error;
    }
};
export const duplicateRestaurantItems = async (targetRestaurantId, type, sourceIds) => {
    try {
        const response = await apiClient.post(`/v1/restaurant/${targetRestaurantId}/duplicate`, { type, sourceIds });
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur duplication ${type}`, error);
        throw error;
    }
};
export const duplicateRestaurantItemsBatch = async (targetRestaurantIds, type, sourceIds) => {
    try {
        const response = await apiClient.post(`/v1/restaurant/duplicate/batch`, { type, sourceIds, targetRestaurantIds });
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur duplication BATCH ${type}`, error);
        throw error;
    }
};
// --- INGREDIENT CATEGORIES ---
export const listeIngredientCategories = async (page = 1, limit = 100, restaurantId) => {
    try {
        let url = `/v1/ingredient-category/all?page=${page}&limit=${limit}`;
        if (restaurantId) {
            url += `&restaurantId=${restaurantId}`;
        }
        const response = await apiClient.get(url);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur liste ingredient categories", error);
        throw error;
    }
};
export const createIngredientCategory = async (data) => {
    try {
        const response = await apiClient.post(`/v1/ingredient-category`, data);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur creation ingredient category", error);
        throw error;
    }
};
export const updateIngredientCategory = async (id, data) => {
    try {
        const response = await apiClient.put(`/v1/ingredient-category/${id}`, data);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur update ingredient category", error);
        throw error;
    }
};
export const deleteIngredientCategory = async (id) => {
    try {
        const response = await apiClient.delete(`/v1/ingredient-category/${id}`);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur suppression ingredient category", error);
        throw error;
    }
};
export const getDuplicateJobStatus = async (jobId) => {
    try {
        const response = await apiClient.get(`/v1/jobs/${jobId}`);
        return response.data;
    }
    catch (error) {
        console.error("❌ Erreur statut duplication", error);
        throw error;
    }
};
export const getPosConfig = async (franchiseId) => {
    try {
        const response = await apiClient.get(`/v1/integrations/pos/config/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur config POS franchise ${franchiseId}`, error);
        throw error;
    }
};
export const updatePosConfig = async (franchiseId, apiKey) => {
    try {
        const response = await apiClient.post(`/v1/integrations/pos/config/${franchiseId}`, { apiKey });
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur mise à jour config POS franchise ${franchiseId}`, error);
        throw error;
    }
};
export const pushPosHistory = async (franchiseId, restaurantId, startDate, endDate) => {
    try {
        const response = await apiClient.post(`/v1/integrations/pos/historical-push/${franchiseId}`, { restaurantId, startDate, endDate });
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur push historique POS franchise ${franchiseId}`, error);
        throw error;
    }
};
export const getPosOrderCount = async (franchiseId, restaurantId, startDate, endDate) => {
    try {
        const response = await apiClient.get(`/v1/integrations/pos/order-count/${franchiseId}`, { params: { restaurantId, startDate, endDate } });
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur count orders POS franchise ${franchiseId}`, error);
        throw error;
    }
};
export const getFranchiseRestaurants = async (franchiseId) => {
    try {
        const response = await apiClient.get(`/v1/restaurant/franchise/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur fetching restaurants for franchise ${franchiseId}`, error);
        throw error;
    }
};
export const pingPosConfig = async (franchiseId) => {
    try {
        const response = await apiClient.get(`/v1/integrations/pos/ping/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error(`❌ Erreur ping POS franchise ${franchiseId}`, error);
        throw error;
    }
};
export const getAdminLoyaltyTransactions = async (page = 1, limit = 20, restaurantId, franchiseId, userId, startDate, endDate) => {
    try {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
        });
        if (restaurantId && restaurantId !== "all") {
            params.append("restaurantId", restaurantId);
        }
        if (franchiseId && franchiseId !== "all") {
            params.append("franchiseId", franchiseId);
        }
        if (userId) {
            params.append("userId", userId);
        }
        if (startDate) {
            params.append("startDate", startDate);
        }
        if (endDate) {
            params.append("endDate", endDate);
        }
        const response = await apiClient.get(`/v1/loyalty/transactions/admin?${params.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération transactions fidélité admin", error);
        throw error;
    }
};
export const getAdminLoyaltyCustomers = async (page = 1, limit = 20, restaurantId, franchiseId, startDate, endDate, search) => {
    try {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
        });
        if (restaurantId && restaurantId !== "all") {
            params.append("restaurantId", restaurantId);
        }
        if (franchiseId && franchiseId !== "all") {
            params.append("franchiseId", franchiseId);
        }
        if (startDate) {
            params.append("startDate", startDate);
        }
        if (endDate) {
            params.append("endDate", endDate);
        }
        if (search) {
            params.append("search", search);
        }
        const response = await apiClient.get(`/v1/loyalty/admin/customers?${params.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération clients fidélité admin", error);
        throw error;
    }
};
export const adminAdjustLoyaltyPoints = async (data) => {
    try {
        const response = await apiClient.post("/v1/loyalty/admin/adjust-points", data);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de l'ajustement des points", error);
        throw error;
    }
};
export const adminReverseLoyaltyTransaction = async (data) => {
    try {
        const response = await apiClient.post("/v1/loyalty/admin/reverse-transaction", data);
        return new ApiResponse(response.data.code, response.data.message, response.data.data);
    }
    catch (error) {
        console.error("❌ Erreur lors de l'annulation de la transaction", error);
        throw error;
    }
};
// ============================================================
// LOYALTY PRODUCTS — Produits Fidélité Style MCDO
// ============================================================
export const getLoyaltyProducts = async (franchiseId, restaurantId) => {
    try {
        const params = new URLSearchParams({ franchiseId });
        if (restaurantId)
            params.append("restaurantId", restaurantId);
        const response = await apiClient.get(`/v1/loyalty/products?${params.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération produits fidélité", error);
        throw error;
    }
};
export const getLoyaltyProductById = async (id) => {
    try {
        const response = await apiClient.get(`/v1/loyalty/products/${id}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const createLoyaltyProduct = async (data) => {
    try {
        const response = await apiClientFormData.post("/v1/loyalty/products", data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur création produit fidélité", error);
        throw error;
    }
};
export const updateLoyaltyProduct = async (id, data) => {
    try {
        const response = await apiClientFormData.put(`/v1/loyalty/products/${id}`, data);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const toggleLoyaltyProduct = async (id) => {
    try {
        const response = await apiClient.patch(`/v1/loyalty/products/${id}/toggle`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const deleteLoyaltyProduct = async (id) => {
    try {
        const response = await apiClient.delete(`/v1/loyalty/products/${id}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const getLoyaltyActivationStats = async (franchiseId) => {
    try {
        const response = await apiClient.get(`/v1/loyalty/activation/stats?franchiseId=${franchiseId}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
};
export const searchLoyaltyProducts = async (search, lang, franchiseId, restaurantId) => {
    try {
        const params = new URLSearchParams({ search, lang });
        if (franchiseId)
            params.append("franchiseId", franchiseId);
        if (restaurantId)
            params.append("restaurantId", restaurantId);
        const response = await apiClient.get(`/v1/product/search-loyalty?${params.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la recherche des produits de fidélité", error);
        throw error;
    }
};
// ============================================================
// SOCIAL MARKETING — Flux, Posts, Comptes et Messages
// ============================================================
export const getSocialAccounts = async (franchiseId) => {
    try {
        const response = await marketingApiClient.get(`/social-media/accounts/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération comptes sociaux", error);
        throw error;
    }
};
export const getSocialFeeds = async (franchiseId) => {
    try {
        const response = await marketingApiClient.get(`/social-media/feeds/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération flux sociaux", error);
        throw error;
    }
};
export const getSocialPosts = async (franchiseId) => {
    try {
        const response = await marketingApiClient.get(`/social-media/posts/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération posts sociaux", error);
        throw error;
    }
};
export const createSocialPost = async (postData) => {
    try {
        const response = await marketingApiClient.post("/social-media/posts", postData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur création post social", error);
        throw error;
    }
};
export const getSocialMessages = async (franchiseId) => {
    try {
        const response = await marketingApiClient.get(`/social-media/messages/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération messages sociaux", error);
        throw error;
    }
};
export const getMarketingAttribution = async (franchiseId, params) => {
    try {
        const response = await marketingApiClient.get(`/marketing/attribution/${franchiseId}`, { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération attribution marketing", error);
        throw error;
    }
};
export const getDeletedOrdersAcrossFranchise = async (franchiseId, page = 1, limit = 20, restaurantId) => {
    try {
        const response = await apiClient.get(`/v1/orders/franchise/deleted`, { params: { franchiseId, restaurantId, page, limit } });
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération commandes supprimées", error);
        throw error;
    }
};
export const restoreOrder = async (id) => {
    try {
        const response = await apiClient.put(`/v1/orders/${id}`, { status: "delivered" });
        return response.data;
    }
    catch (error) {
        console.error("Erreur restauration commande", error);
        throw error;
    }
};
/**
 * 📊 Rapports analytiques avancés
 */
export const getAdvancedSalesReport = async (params) => {
    try {
        const response = await apiClient.get('/statistics/advanced-analytics', { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur rapports avancés", error);
        throw error;
    }
};
export const getTvaReport = async (params) => {
    try {
        const response = await apiClient.get('/statistics/tva-report', { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur rapport TVA", error);
        throw error;
    }
};
export const getDeletedOrders = async (params) => {
    try {
        const response = await apiClient.get('/statistics/deleted-orders', { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur rapport commandes supprimées", error);
        throw error;
    }
};
/**
 * 🧾 Résumé de clôture (Shift Summary)
 */
export const getShiftSummary = async (restaurantId, date) => {
    try {
        const response = await apiClient.get(`/statistics/shift-summary/${restaurantId}`, { params: { date } });
        return response.data;
    }
    catch (error) {
        console.error("Erreur shift summary", error);
        throw error;
    }
};
/**
 * 🔒 Fermetures exceptionnelles
 */
export const listClosures = async (params) => {
    try {
        const response = await apiClient.get('/restaurant-closure', { params });
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des fermetures", error);
        throw error;
    }
};
export const createClosure = async (data) => {
    try {
        const response = await apiClient.post('/restaurant-closure', data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la création d'une fermeture", error);
        throw error;
    }
};
export const updateClosure = async (id, data) => {
    try {
        const response = await apiClient.patch(`/restaurant-closure/${id}`, data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la mise à jour d'une fermeture", error);
        throw error;
    }
};
export const deleteClosure = async (id) => {
    try {
        const response = await apiClient.delete(`/restaurant-closure/${id}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la suppression d'une fermeture", error);
        throw error;
    }
};
export const getExportCsv = async (filters) => {
    try {
        const queryParams = new URLSearchParams();
        if (filters.restaurantId && filters.restaurantId !== "all")
            queryParams.append("restaurantId", filters.restaurantId);
        queryParams.append("startDate", filters.startDate);
        queryParams.append("endDate", filters.endDate);
        const response = await apiClient.get(`/statistics/export-csv?${queryParams.toString()}`, {
            responseType: 'blob'
        });
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `export-ventes-${filters.startDate}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
    }
    catch (error) {
        console.error("Erreur lors de l'export CSV", error);
        throw error;
    }
};
export const getAdvancedAnalytics = async (filters) => {
    try {
        const queryParams = new URLSearchParams();
        if (filters.restaurantId && filters.restaurantId !== "all")
            queryParams.append("restaurantId", filters.restaurantId);
        queryParams.append("startDate", filters.startDate);
        queryParams.append("endDate", filters.endDate);
        if (filters.startTime)
            queryParams.append("startTime", filters.startTime);
        if (filters.endTime)
            queryParams.append("endTime", filters.endTime);
        // @ts-ignore
        if (filters.deliveryZone)
            queryParams.append("deliveryZone", filters.deliveryZone);
        const response = await apiClient.get(`/statistics/advanced-analytics?${queryParams.toString()}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur alors de la récupération des analytics avancées", error);
        throw error;
    }
};
/**
 * 📣 Automatisations Marketing
 */
export const getAutomationConfigs = async (franchiseId) => {
    try {
        const response = await marketingApiClient.get(`/automation/${franchiseId}`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération configs automation", error);
        throw error;
    }
};
export const upsertAutomationConfig = async (franchiseId, data) => {
    try {
        const response = await marketingApiClient.put(`/automation/${franchiseId}`, data);
        return response.data;
    }
    catch (error) {
        console.error("Erreur upsert automation", error);
        throw error;
    }
};
export const toggleAutomationConfig = async (id) => {
    try {
        const response = await marketingApiClient.patch(`/automation/config/${id}/toggle`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur toggle automation", error);
        throw error;
    }
};
export const getAutomationLogs = async (franchiseId, limit = 100, offset = 0) => {
    try {
        const response = await marketingApiClient.get(`/automation/${franchiseId}/logs`, {
            params: { limit, offset }
        });
        return response.data;
    }
    catch (error) {
        console.error("Erreur récupération logs automation", error);
        throw error;
    }
};
export const uploadSocialMedia = async (fileData) => {
    try {
        const response = await marketingApiClient.post('/social-media/upload', fileData);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de l'upload social media", error);
        throw error;
    }
};
export const getMasterPostalCodes = async () => {
    try {
        const response = await apiClient.get(`/code-postal`);
        return response.data;
    }
    catch (error) {
        console.error("Erreur lors de la récupération des codes postaux (master)", error);
        throw error;
    }
};
